/* @flow */

import React from "react";

function Spinner(props: { variant?: string }) {
    const className = "m-spinner" + (props.variant ? " m-spinner-" + props.variant : "");
    return (
        <span className="m">
            <div className={className}>
                <svg className="m-spinner-svg" viewBox="25 25 50 50">
                    <circle
                        className="m-spinner-path"
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                        strokeWidth="1"
                        strokeMiterlimit="10"
                    />
                </svg>
            </div>
        </span>
    );
}

export default Spinner;
